import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { requestInterceptor, responseInterceptor } from './service/axios/axios-interceptor';
import * as serviceWorker from './serviceWorker';
import { ThemeProvider } from '@mui/material';
import theme from './app/app-theme';
import React from 'react';
import { setupStore } from './app/store';

requestInterceptor();
responseInterceptor();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const store = setupStore();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
serviceWorker.register();
